// The types of elements that can be selected and edited in the email editor sidebar.
export enum SelectionElement {
  Text = "text",
  Image = "image",
  Block = "block",
}

/**
 * Inline text formats reachable by keyboard shortcut, which the iframe
 * intercepts and routes to the editor's own guarded toggle handlers rather
 * than letting native execCommand inject markup.
 */
export type InlineTextFormat =
  | "bold"
  | "italic"
  | "underline"
  | "superscript"
  | "subscript";

/** ImageSettings keys the sidebar can write back to the element —
 * `isBackground` describes the target kind and is read-only. */
export type ImageSettingField = Exclude<keyof ImageSettings, "isBackground">;

export type ImageSettings = {
  src: string;
  /** True when the target paints an inline background image (div/td hero)
   * rather than being an <img> — hides img-only controls (alt, object-fit). */
  isBackground: boolean;
  alt: string;
  borderRadius: string;
  baseWidth: number;
  baseHeight: number;
  width: string;
  height: string;
  objectFit: string;
  paddingTop: string;
  paddingRight: string;
  paddingBottom: string;
  paddingLeft: string;
  marginTop: string;
  marginRight: string;
  marginBottom: string;
  marginLeft: string;
};

export type TextStyles = {
  fontFamily: string;
  fontSize: string;
  fontWeight: string;
  fontStyle: string;
  textAlign: string;
  textDecoration: string;
  /** Baseline shift, and the backing field for the mutually exclusive
   * superscript/subscript toggles — only "super" and "sub" are meaningful
   * here, so setting one necessarily clears the other. */
  verticalAlign: string;
  color: string;
};

export type BlockStyles = {
  width: string;
  height: string;
  paddingTop: string;
  paddingRight: string;
  paddingBottom: string;
  paddingLeft: string;
  marginTop: string;
  marginRight: string;
  marginBottom: string;
  marginLeft: string;
  backgroundColor: string;
};
